import { useEffect, useState  } from 'react';

//disable right click 
const useDisableRightClick = () => {
  useEffect(() => {
    const handleRightClick = (event: MouseEvent) => {
      if (!event.ctrlKey) {
        event.preventDefault();
      }
    };
    document.addEventListener('contextmenu', handleRightClick);
    return () => {
      document.removeEventListener('contextmenu', handleRightClick);
    };
  }, []);
};

//Disabling Text Selection
const useDisableTextSelect = () => {
  useEffect(() => {
    document.body.style.userSelect = "none";
    return () => {
      document.body.style.userSelect = "";
    };
  }, []);
};

// Copy text with class 'copy' on double-click
const useCopyTextOnDoubleClick = () => {
  const [copiedElement, setCopiedElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const handleDoubleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.classList.contains("copy") && !event.ctrlKey) {
        event.preventDefault();
        let text: string = target.innerText.trim();
        console.log("text--->",text);
        if (text.includes("#")) {
          text = text.replace('#','');
          text = `.${text}.`;
        }
        navigator.clipboard.writeText(text);
        target.classList.add("copied");
        setCopiedElement(target);
        setTimeout(() => {
          target.classList.remove("copied");
          setCopiedElement(null);
        }, 500);
      }
    };

    document.addEventListener("dblclick", handleDoubleClick);
    return () => {
      document.removeEventListener("dblclick", handleDoubleClick);
    };
  }, []);

  return { copiedElement };
};

//common function will call on list page
const ListCommonActions = () => {
  useDisableRightClick();
  useDisableTextSelect();
  useCopyTextOnDoubleClick();

  return null;
};

//common function will call on form page
const FormCommonActions = () => {
  useDisableRightClick();
  useDisableTextSelect();
  useCopyTextOnDoubleClick();

  return null;
};

//common function will call on print page
const PrintCommonActions = () => {
  useDisableRightClick();
  useDisableTextSelect();
  useCopyTextOnDoubleClick();

  return null;
};

//common function will call on Calendar page
const CalendarCommonActions = () => {
  useDisableRightClick();
  useDisableTextSelect();
  useCopyTextOnDoubleClick();

  return null;
};

//common function will call on Report page
const ReportCommonActions = () => {
  useDisableRightClick();
  useDisableTextSelect();
  useCopyTextOnDoubleClick();

  return null;
};

export const Actions = {
  List: ListCommonActions,
  Form: FormCommonActions,
  Print: PrintCommonActions,
  Calendar: CalendarCommonActions,
  Report: ReportCommonActions,
}